
    <div fxLayout="row wrap" fxLayoutAlign="space-between center" class="w-100 p-2" >
        <span *ngIf="currentAmount != 0">
            <button *ngIf="numeroCompte && numeroCompte.numero_compte_operateur != null" mat-raised-button color="primary" (click)="createTransfer()">
                <mat-icon>add</mat-icon>
                Demander un virement
            </button>
            <button *ngIf="numeroCompte && numeroCompte.numero_compte_operateur == null"  mat-raised-button color="warn" routerLink="/compte-utilisateur/mes-paiements/mon-porte-monaie">
                Mettre à jour mon porte monaie
            </button>
        </span>
    </div>
    <div fxLayout="row wrap">
        <div fxFlex="50" fxFlex.xl="16.6" fxFlex.lg="33.3" fxFlex.md="33.3" fxFlex.sm="33.3" class="p-2">        
            <mat-card class="gradient-green tile p-2"> 
                <mat-icon>monetization_on</mat-icon> 
                <h2>{{revenuetotal}} {{currency}}</h2>         
                <p>Mon profit depuis le {{ this.user?.created_at | date:"dd MMMM, yyyy 'à' HH:mm" }}</p>            
            </mat-card>
        </div>
        <div fxFlex="50" fxFlex.xl="16.6" fxFlex.lg="33.3" fxFlex.md="33.3" fxFlex.sm="33.3" class="p-2">        
            <mat-card class="gradient-red tile p-2"> 
                <mat-icon>trending_down</mat-icon> 
                <h2>{{currentAmount}} {{currency}}</h2>         
                <p>Montant actuel</p>            
            </mat-card>
        </div>
        <div fxFlex="50" fxFlex.xl="16.6" fxFlex.lg="33.3" fxFlex.md="33.3" fxFlex.sm="33.3" class="p-2">
            <mat-card class="gradient-brown tile p-2">
                <mat-icon>trending_up</mat-icon> 
                <h2>{{transferTotal}} {{currency}}</h2>         
                <p>Montant virement</p> 
            </mat-card>
        </div> 
        <div fxFlex="50" fxFlex.xl="16.6" fxFlex.lg="16.6" fxFlex.md="33.3" fxFlex.sm="33.3" class="p-2">
            <mat-card class="gradient-orange tile p-2">
                <mat-icon>autorenew</mat-icon> 
                <h2>{{amountOutstanding}} {{currency}}</h2>         
                <p>Montant Encours</p> 
            </mat-card>
        </div>     
    </div>

<div fxLayout="row wrap">
    <div fxFlex="100" fxFlex.gt-sm="100" class="p-2"> 
        <app-income-table></app-income-table>
    </div>
</div>

<div fxLayout="row wrap">
    <div fxFlex="100" fxFlex.gt-sm="100" class="p-2"> 
        <app-transfer-table [valueChange]="valueChange" [key]="'RENTING'"></app-transfer-table>
    </div>
</div>
